import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { FormFieldProvider } from './form-field.context';

/**
 * @typedef Props
 * @prop  {React.ReactNode} children
 * @prop  {string} [className]
 */
/**
 * @param {Props & {[x: string]: any;}} props
 */
const MotifFormField = (props) => {
  const { children, className = '', ...other } = props;

  const [disabled, setDisabled] = useState(false);

  const [formElementType, setFormElementType] = useState(null);

  const [hasPlaceholder, setHasPlaceholder] = useState(null);

  const [id, setId] = useState('');

  const [invalid, setInvalid] = useState(false);

  const [required, setRequired] = useState(false);

  const [value, setValue] = useState(null);

  const [hasContent, setHasContent] = useState(false);

  const [isFocused, setFocus] = useState(false);

  const [isActive, setActive] = useState(false);

  const handleToggleFocus = isFocusedValue => {
    const focusValue = typeof isFocusedValue === 'boolean' ? isFocusedValue : !isFocused;
    setFocus(focusValue);
  };

  const classes = classNames({
    'motif-form-field': true,
    'motif-form-field-focused': isFocused,
    'motif-form-field-has-placeholder': hasPlaceholder,
    'motif-form-field-has-value': hasContent,
    'motif-form-field-select-input': formElementType === 'selectInput',
    'motif-form-field-text-input': formElementType === 'textInput',
    'motif-form-field-date-input': formElementType === 'dateInput',
    [className]: true
  });

  const contextSettings = {
    disabled,
    formElementType,
    hasContent,
    hasPlaceholder,
    id,
    invalid,
    isFocused,
    isActive,
    required,
    value,
    setDisabled,
    setActive,
    setFormElementType,
    setHasContent,
    setHasPlaceholder,
    setId,
    setInvalid,
    setRequired,
    setValue,
    toggleFocus: handleToggleFocus
  };

  return (
    <FormFieldProvider value={contextSettings}>
      <div {...other} className={classes} data-motif-form-field>
        {children}
      </div>
    </FormFieldProvider>
  );
};

MotifFormField.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export { MotifFormField };
